"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const OTHER = '__other__';
function CheckerSelect({ checkers, value, onChange, storageKey = 'printCheckerLast', style, }) {
    const [other, setOther] = (0, react_1.useState)(!value.staffId && !!value.name);
    // Pre-select whoever checked last on this device, if they're still on the list.
    (0, react_1.useEffect)(() => {
        if (value.staffId || value.name)
            return;
        try {
            const last = JSON.parse(localStorage.getItem(storageKey) || 'null');
            if (last?.staffId && checkers.some((c) => c.id === last.staffId))
                onChange(last);
            else if (last?.name && !last.staffId) {
                setOther(true);
                onChange(last);
            }
        }
        catch {
            /* nothing remembered */
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkers]);
    const remember = (v) => {
        try {
            localStorage.setItem(storageKey, JSON.stringify(v));
        }
        catch {
            /* private mode etc. */
        }
        onChange(v);
    };
    const base = { width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit', background: 'white', ...style };
    return ((0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', flexDirection: 'column', gap: 6 }, children: [(0, jsx_runtime_1.jsxs)("select", { value: other ? OTHER : value.staffId, onChange: (e) => {
                    if (e.target.value === OTHER) {
                        setOther(true);
                        onChange({ staffId: '', name: '' });
                    }
                    else {
                        setOther(false);
                        const c = checkers.find((x) => x.id === e.target.value);
                        remember(c ? { staffId: c.id, name: c.name } : { staffId: '', name: '' });
                    }
                }, style: base, "aria-label": "Checked by", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Checked by\u2026" }), checkers.map((c) => ((0, jsx_runtime_1.jsxs)("option", { value: c.id, children: [c.name, c.role ? ` - ${c.role}` : ''] }, c.id))), (0, jsx_runtime_1.jsx)("option", { value: OTHER, children: "Someone else (type a name)" })] }), other && ((0, jsx_runtime_1.jsx)("input", { value: value.name, onChange: (e) => onChange({ staffId: '', name: e.target.value }), onBlur: () => value.name.trim() && remember({ staffId: '', name: value.name.trim() }), placeholder: "Their name", style: base }))] }));
}
exports.default = CheckerSelect;
